import { useTranslation } from '@packages/utils';
import { FormItem } from 'components/Base/Form';
import Checkbox from 'components/Base/Checkbox';

const RegistrationModalForm = ({
  registrationModalKey,
}: {
  registrationModalKey: string;
}) => {
  const { t } = useTranslation({
    lng: 'translate',
  });

  return (
    <FormItem
      name="recieveEmail"
      valuePropName="checked"
      data-cy="registration-email-notification"
    >
      <Checkbox>
        {t(`${registrationModalKey}.RECEIVE_NOTIFICATION_CHECKBOX_TEXT`)}
      </Checkbox>
    </FormItem>
  );
};

export default RegistrationModalForm;
